<template>
  <VForm
    v-model="formData"
    ref="positionFormRef"
  >

    <!--  Внимание!!! При добавлении новых полей, нужно также прописывать -->
    <!--  правила валидации в файле spa/src/utils/production/position/validation.js -->
    <!--  (проверка в заказе перед перед передачей в статус на запуск)-->
    <!--  Для полей необязательных на начальном статусе заказа isRequiredForOrderStatusChange-->
    <div v-if="(isType1 || isType2) && !isCatalog" class="position v-form--grid custom-scroll">
        <div class="position__item col-1" style="order: 1">
            <VSelect
                label="Вид пружины"
                name="shape"
                :style="isMobile ? 'max-width: 425px' : ''"
                :options="isType1 ? shapeAll : shapeType2"
                :disabled="isDisabled || isDisabledForShipped"
                :required="isRequired"
            >
                <Validation for="required"/>
            </VSelect>
        </div>
    </div>

    <div
        v-if="(!(isType1 || isType2) || formData.shape) || isCatalog"
        class="position v-form--grid custom-scroll mt-20"
    >
        <!--1 Столбец-->
        <!--1 строка-->
        <div class="position__item col-1 row-1">
        <VInput
            label="d проволоки"
            name="d_wire"
            :width="isType17 ? '55%' : ''"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :required="isRequired"
            :pattern="pattern.num100"
        >
            <Validation for="required" />
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <VInput
            v-if="notType4"
            :label="isType127 ? 'Индекс (i) 1' : 'Индекс (i)'"
            name="index"
            width="50%"
            disabled
        />
        <VInput
            v-if="isType127 && isShape"
            label="Индекс (i) 2"
            name="index_2"
            width="50%"
            disabled
        />

        <VInput
            v-if="visibleStiffness"
            label="Жесткость, Н/мм"
            name="stiffness"
            width="50%"
            disabled
        />
        </div>

        <!--2 строка-->
        <div class="position__item col-1 row-2" >
        <VInput
            v-if="visibleDInner"
            label="D внутренний"
            name="d_inner"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required" />
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <VInput
            v-if="visibleDOutput"
            :label="isType127 && isShape ? 'D1 больший' : 'D наружный'"
            name="d_outer_1"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required" />
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <VInput
            v-if="isType127 && isShape"
            label="D1 меньший"
            name="d_outer_2"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required"/>
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <VInput
            v-if="isType4"
            label="Габаритная длина изделия"
            name="overall_length"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VInput>
        </div>

        <!--3 строка-->
        <div class="position__item col-1 row-3">
        <VInput
            v-if="notType48"
            label="Длина тела (L0)"
            name="body_length"
            :width="visiblePerpendicularity ? '50%' : null"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required"/>
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <InputCopy
            v-if="visiblePerpendicularity"
            label="Перпендикулярность, ⊥"
            name="perpendicularity"
            :model-copy="calcPerpendicularity"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        />

        <VInput
            v-if="isType8"
            label="Зазор"
            name="gap"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required"/>
            <Validation for="pattern" key-text="num100"/>
        </VInput>
        </div>

        <!--4 строка-->
        <div class="position__item col-1 row-4">
        <VSelect
            v-if="isType17"
            label="Опорный виток 1"
            name="reference_turn_1"
            :options="propertiesAll.reference_turn"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VSelect>

        <VSelect
            v-if="isType17"
            label="Опорный виток 2"
            name="reference_turn_2"
            :options="propertiesAll.reference_turn"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VSelect>

        <VInput
            v-if="isType359"
            label="Число рабочих витков (n)"
            name="number_turns"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required" />
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <VInput
            v-if="isType2"
            label="Длина по зацепам"
            name="length_by_hooks"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required" />
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <VInput
            v-if="isType8"
            label="Число полных витков (n1)"
            name="number_full_turns"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required"/>
            <Validation for="pattern" key-text="num100"/>
        </VInput>
        </div>

        <!--5 строка-->
        <div class="position__item col-1 row-5">
        <VInput
            v-if="isType1"
            label="Число рабочих витков (n)"
            name="number_turns"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required" />
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <VInput
            v-if="isType1"
            label="Число полных витков (n1)"
            name="number_full_turns"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :pattern="pattern.num100"
        >
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <VInput
            v-if="isType7"
            label="Число витков на цилиндр"
            name="number_turn_cylinder"
            :lengthTooltip="5"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required"/>
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <VInput
            v-if="isType7"
            label="Число витков на конус"
            name="number_turn_cone"
            :disabled="isDisabled || isDisabledForShipped"
            :pattern="pattern.num100"
        >
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <VInput
            v-if="isType359"
            label="Длина отвода 1"
            name="tap_length_1"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange && isType35"
        >
            <Validation for="required" v-if="isType35"/>
        </VInput>

        <VSelect
            v-if="isType2"
            label="Тип зацепа 1"
            name="hook_type_1"
            :options="propertiesAll.hook_type"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VSelect>

        <VSelect
            v-if="isType8"
            label="Плоскостность"
            name="flatness"
            :options="propertiesAll.flatness"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VSelect>
        </div>

        <!--6 строка-->
        <div class="position__item col-1 row-6">
        <VInput
            v-if="isType7"
            label="Число полных витков (n1)"
            name="number_full_turns"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required" />
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <InputCopy
            v-if="isType1"
            label="Шаг (t)"
            name="step"
            :model-copy="calcStep"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            pattern-key="num100"
        />

        <VInput
            v-if="isType359"
            label="Длина отвода 2"
            name="tap_length_2"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange && isType35"
        >
            <Validation for="required" v-if="isType35"/>
        </VInput>

        <VSelect
            v-if="isType2"
            label="Тип зацепа 2"
            name="hook_type_2"
            :options="propertiesAll.hook_type"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VSelect>

        <VSelect
            v-if="isType8"
            label="Фаска"
            name="chamfer"
            :options="propertiesAll.chamfer"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VSelect>
        </div>

        <!--7 строка-->
        <div v-if="isType2 || isType5" class="position__item col-1 row-7" >
        <VSelect
            v-if="isType2"
            label="Ориентация зацепов"
            name="hook_orientation_1"
            :options="propertiesAll.hook_orientation"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VSelect>

        <VInput
            v-if="isType5"
            label="Длина зацепа"
            name="hook_length_1"
            :disabled="isDisabled || isDisabledForShipped"
        />
        </div>
      <!--8 строка-->
      <div v-if="isType2" class="position__item col-1 row-8" >
      </div>

        <!--9 строка-->
        <div class="position__item position__item--comment col-1 row-9 relative" >
            <VInput
                label="Комментарий для производства"
                type="editor"
                name="comment"
                :disabled="isDisabled"
                :required="!isTemptate && !isCatalog && isRequiredForOrderStatusChange"
            >
                <Validation for="required"/>
            </VInput>

            <div class="comment-buttons flex gap-xxs">
                <VButton
                    v-if="!isDisabled && !isTemptate && !isCatalog"
                    text="СЗ"
                    icon="create"
                    size="sm"
                    @click.native="$emit('copyRelativeOrders')"
                />

                <VButton
                    v-if="!isDisabled && !isTemptate && !isCatalog"
                    text="ПП"
                    icon="create"
                    size="sm"
                    @click.native="$emit('copyNoteManufacture')"
                />
            </div>
        </div>

        <!--2 Столбец-->
        <!--1 строка-->
        <div class="position__item col-2 row-1">
          <VSelect
              v-if="notType4"
              label="Направление навивки"
              name="winding_dir"
              :options="propertiesAll.winding_direction"
              :disabled="isDisabled || isDisabledForShipped"
              :required="isRequiredForOrderStatusChange && !isType5"
          >
              <Validation for="required" v-if="!isType5"/>
          </VSelect>

          <VInput
              v-if="isType9"
              label="Ориентация отводов"
              name="tap_orientation"
              :disabled="isDisabled || isDisabledForShipped"
              :required="isRequiredForOrderStatusChange && isType35"
              :pattern="pattern.num"
          >
              <Validation for="required" v-if="isType35"/>
              <Validation for="pattern" key-text="num"/>
          </VInput>

          <div class="d-flex gap-xxs ai-fe">
            <VInput
              v-if="isType35"
              label="Угол м/у отводами и зацепом"
              name="tap_angle"
              :disabled="isDisabled || isDisabledForShipped"
              :required="isRequiredForOrderStatusChange"
              :pattern="pattern.num"
            >
              <Validation for="required"/>
              <Validation for="pattern" key-text="num"/>
            </VInput>
            <VInput
              v-if="isType35"
              label="Допуск на угол"
              name="tap_angle_limit"
              :disabled="isDisabled || isDisabledForShipped"
            />
          </div>
        </div>

        <!--2 строка-->
        <div class="position__item col-2 row-2">
        <InputCopy
            v-if="visibleDOutput"
            :label="isType127 && isShape? 'Допуск по D1 большему' : 'Допуск по D наруж.'"
            name="d_outer_1_limit"
            :model-copy="calcDiameterLimit"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange"
        />

        <InputCopy
            v-if="isType127 && isShape"
            label="Допуск по D1 меньшему"
            name="d_outer_2_limit"
            :model-copy="calcDOuterLimit2"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange"
        />

        <InputCopy
            v-if="visibleDInner"
            label="Допуск по D внутр."
            name="d_inner_limit"
            :model-copy="calcDInnerLimit"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange"
        />

        <VInput
            v-if="isType4"
            label="Допуск на линейные размеры"
            name="linear_size_limit"
            :disabled="isDisabled"
        />
        </div>

        <!--3 строка-->
        <div class="position__item col-2 row-3">
          <InputCopy
            v-if="isType8"
            label="Допуск на зазор"
            name="gap_limit"
            :model-copy="calcClearanceTolerance"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange"
          />
          <div class="d-flex gap-xxs ai-fe w-100" v-if="isType2">
            <VInput
              label="Число рабочих витков (n)"
              name="number_turns"
              :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
              :required="isRequiredForOrderStatusChange"
              :pattern="pattern.num100"
            >
              <Validation for="required"/>
              <Validation for="pattern" key-text="num100"/>
            </VInput>
            <VInput
              v-if="isShapeCone"
              label="Число витков на конус"
              name="number_turn_cone"
              :disabled="isDisabled || isDisabledForShipped"
              :required="isRequiredForOrderStatusChange"
              :pattern="pattern.num100"
            >
              <Validation for="required"/>
              <Validation for="pattern" key-text="num100"/>
            </VInput>
          </div>
          <!--    Для стопорных колец выводим на следующей строке так как на этой строке уже выводится допуск на зазор     -->
          <InputCopy
            v-if="visibleTurnsLimit && !isType8"
            label="Допуск по виткам"
            name="turns_limit"
            :model-copy="calcTurnsLimit"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange"
          />
          <VSelect
            v-if="isType35"
            label="Тип навивки"
            name="winding_type"
            :options="propertiesAll.winding_type"
            :required="isRequiredForOrderStatusChange"
            :disabled="isDisabled || isDisabledForShipped"
          >
            <Validation for="required"/>
          </VSelect>
        </div>

        <!--4 строка-->
        <div class="position__item col-2 row-4">
          <InputCopy
            v-if="notType48"
            label="Допуск по длине"
            name="body_length_limit"
            :model-copy="calcBodyLengthLimit"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange"
          />

          <!--   Вывод на этой строке только для стопорных колец       -->
          <InputCopy
            v-if="isType8"
            label="Допуск по виткам"
            name="turns_limit"
            :model-copy="calcTurnsLimit"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange"
          />
        </div>

        <!--5 строка-->
        <div class="position__item col-2 row-5" >
          <VSelect
            v-if="isType8"
            label="Загибы"
            name="folds"
            :options="propertiesAll.fold"
            :disabled="isDisabled || isDisabledForShipped"
          >
            <Validation for="required"/>
          </VSelect>
        <InputCopy
            v-if="isType359"
            label="Допуск на длину отвода 1"
            name="tap_length_1_limit"
            :model-copy="calcTapLengthLimit1"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange && isType35"
        />

        <VInput
            v-if="isType2"
            label="Длина зацепа 1"
            name="hook_length_1"
            :required="isRequiredForOrderStatusChange"
            :disabled="isDisabled || isDisabledForShipped"
        >
            <Validation for="required"/>
        </VInput>
        </div>

        <!--6 строка-->
        <div class="position__item col-2 row-6">
        <InputCopy
            v-if="isType359"
            label="Допуск на длину отвода 2"
            name="tap_length_2_limit"
            :model-copy="calcTapLengthLimit2"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange && isType35"
        />

        <VInput
            v-if="isType2"
            label="Длина зацепа 2"
            name="hook_length_2"
            :required="isRequiredForOrderStatusChange"
            :disabled="isDisabled || isDisabledForShipped"
        >
            <Validation for="required"/>
        </VInput>

        <InputCopy
            v-if="isType7"
            label="Шаг (t)"
            name="step"
            :model-copy="calcStep"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            pattern-key="num100"
        />

        <InputCopy
            v-if="isType17"
            label="Допуск на шаг"
            name="step_limit"
            :model-copy="calcStepLimit"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange"
        />
        </div>

        <!--7 строка-->
        <div v-if="isType2 || isType5" class="position__item col-2 row-7" >
        <VInput
            v-if="isType2"
            label="Зазор зацепа 1"
            name="hook_gap_1"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
        >
            <Validation for="required"/>
            <Validation for="pattern" key-text="num100"/>
        </VInput>

        <InputCopy
          v-if="isType2"
          label="Допуск на зазор 1"
          name="hook_gap_1_limit"
          :model-copy="calcClearanceTolerance2"
          :disabled="isDisabled"
          :required="isRequiredForOrderStatusChange"
        />

        <VInput
            v-if="isType5"
            label="Угол загиба на зацепе"
            name="hook_bend_angle"
            :disabled="isDisabled"
        />
        </div>
      <!--8 строка-->
        <div  v-if="isType2" class="position__item col-2 row-8">
          <VInput
            v-if="isType2"
            label="Зазор зацепа 2"
            name="hook_gap_2"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            :pattern="pattern.num100"
          >
            <Validation for="required"/>
            <Validation for="pattern" key-text="num100"/>
          </VInput>

          <InputCopy
            v-if="isType2"
            label="Допуск на зазор 2"
            name="hook_gap_2_limit"
            :model-copy="calcClearanceTolerance2"
            :disabled="isDisabled"
            :required="isRequiredForOrderStatusChange"
          />
        </div>

        <!--9 строка-->
        <div class="position__item position__item--comment col-2 row-9 relative">
            <VInput
                label="Комментарий для ОТК"
                type="editor"
                name="note_otk"
                :disabled="isDisabled"
                :required="!isTemptate && !isCatalog && isRequiredForOrderStatusChange"
                >
                <Validation for="required"/>
            </VInput>

            <div class="comment-buttons flex gap-xxs">
                <VButton
                    v-if="!isDisabled && !isTemptate && !isCatalog"
                    text="ПО"
                    icon="create"
                    size="sm"
                    @click.native="$emit('copyNoteOTK')"
                />
            </div>
        </div>

        <!--3 Столбец-->
        <!--1 строка-->
        <div class="position__item col-3 row-1">
        <VSelect
            label="Материал"
            name="material"
            :options="propertiesAll.material"
            :disabled="isDisabled || isDisabledForProcessEngineer || isDisabledForShipped"
            :required="isRequired"
        >
            <Validation for="required"/>
        </VSelect>
        </div>

        <!--2 строка-->
        <div class="position__item col-3 row-2">
        <InputCopy
            label="Длина развертки"
            name="sweep_length"
            :model-copy="calcSweepLength"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequired"
            pattern-key="num100"
        />

        <VInput
            label="Масса, кг"
            v-model="calcWeight"
            width="50%"
            disabled
            :required="isRequired"
        >
            <Validation for="pattern" key-text="num100000"/>
            <Validation for="required"/>
        </VInput>
        </div>

        <!--3 строка-->
        <div class="position__item col-3 row-3">
          <InputCopy
            label="Твердость"
            name="hardness"
            :model-copy="calcHardness"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange && !isType9"
          />
        </div>

        <!--4 строка-->
        <div class="position__item col-3 row-4">
          <SelectTooltip
            label="Поверхностная обработка"
            name="surface_treatment"
            :options="propertiesAll.surface_treatment"
            :model-tooltip="calcSurfaceTreatment"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
          />
        </div>

      <!--5 строка-->
        <div class="position__item col-3 row-5">
        <VSelect
            label="Испытания"
            name="tests"
            :options="propertiesAll.test"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VSelect>

        <InputCopy
            v-if="hasProbes"
            label="Количество пробников"
            name="probes"
            :model-copy="calcProbes"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
            pattern-key="num"
        />
        </div>

        <!--6 строка-->
        <div class="position__item col-3 row-6">
        <VSelect
            label="Покрытие"
            name="coating"
            :options="coatingOptionsFiltered"
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VSelect>

        <VInput
            v-if="isDisabled && formData.color_text && !formData.color"
            label="Цвет"
            name="color_text"
            disabled
        />

        <VSelect
            v-else
            label="Цвет"
            name="color"
            :options="colorOptionsFiltered"
            searchable
            :disabled="isDisabled || isDisabledForShipped"
            :required="isRequiredForOrderStatusChange"
        >
            <Validation for="required"/>
        </VSelect>
        </div>
    </div>
  </VForm>
</template>

<script>
import VForm from '@/components/Form/VForm'
import VSelect from '@/components/Form/VSelect'
import VInput from '@/components/Form/Vinput/VInput'
import Validation from '@/components/Form/Validation'
import InputCopy from '@/components/Form/Vinput/InputCopy'
import VButton from '@/components/simple/button/VButton'
import SelectTooltip from '@/components/Form/SelectTooltip'

import { mixinFormData } from '@/mixins/form/mixinFormData'
import { mixinPositionType } from '@/mixins/views/Production/Position/mixinPositionType'
import { mixinPositionCalc } from '@/mixins/views/Production/Position/mixinPositionCalc'

import { mixinCoatingAndColorOptionsFiltered } from '@/mixins/views/mixinCoatingAndColorOptionsFiltered'
import { mixinPositionForm } from '@/mixins/views/Production/Position/mixinPositionForm'

export default {
  name: 'PositionFormDetails',
  components: {
    VForm,
    InputCopy,
    Validation,
    VInput,
    VSelect,
    VButton,
    SelectTooltip
  },
  mixins: [
    mixinFormData,
    mixinPositionType,
    mixinPositionCalc,
    mixinCoatingAndColorOptionsFiltered,
    mixinPositionForm
  ]
}
</script>

<style lang="scss">
.comment-buttons {
  position: absolute;
  top: -3px;
  right: 0;
}
</style>
